import type { ListParams } from '@nucleus-commerce/admin-kit/index-table';
import {
  getAdminV1StoresStoreIdPrivacyRequests,
  getAdminV1StoresStoreIdPrivacyRequestsIdExport,
  patchAdminV1StoresStoreIdPrivacyRequestsId,
  type GetAdminV1StoresStoreIdPrivacyRequests200,
  type PatchAdminV1StoresStoreIdPrivacyRequestsIdBody,
  type PrivacyExportBundle,
  type PrivacyRequest,
} from '@nucleus-commerce/api-client/admin';

/**
 * List params as `listParams` builds them from the route's search: `sort`, the flat filter params
 * (`status=received,in_progress`, `requestedAt_gte=2026-09-01`), `cursor`, `limit`.
 */
export type PrivacyRequestListParams = ListParams;

/** Privacy requests of one store: shoppers file them, staff work them through. */
export const privacyRequestsApi = {
  list: (
    storeId: string,
    params: PrivacyRequestListParams,
  ): Promise<GetAdminV1StoresStoreIdPrivacyRequests200> =>
    getAdminV1StoresStoreIdPrivacyRequests({ storeId }, params),
  update: (
    storeId: string,
    id: string,
    body: PatchAdminV1StoresStoreIdPrivacyRequestsIdBody,
  ): Promise<PrivacyRequest> => patchAdminV1StoresStoreIdPrivacyRequestsId({ storeId, id }, body),
  exportBundle: (storeId: string, id: string): Promise<PrivacyExportBundle> =>
    getAdminV1StoresStoreIdPrivacyRequestsIdExport({ storeId, id }),
};
